/* Custom cursor: a small dot that tracks the pointer exactly, plus a ring
   that trails behind it with easing. The ring expands over interactive
   elements and contracts while pressing. Only activates for fine pointers. */
export class CustomCursor {
  constructor() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    document.documentElement.classList.add("has-custom-cursor");

    this.dot = document.createElement("div");
    this.dot.className = "cursor-dot";
    this.ring = document.createElement("div");
    this.ring.className = "cursor-ring";
    document.body.append(this.ring, this.dot);

    this.x = window.innerWidth / 2;
    this.y = window.innerHeight / 2;
    this.ringX = this.x;
    this.ringY = this.y;
    this.visible = false;

    this.#bindEvents();
    this.#loop();
  }

  #bindEvents() {
    window.addEventListener("mousemove", (e) => {
      this.x = e.clientX;
      this.y = e.clientY;
      if (!this.visible) {
        this.visible = true;
        document.documentElement.classList.add("cursor-active");
      }
    });

    document.addEventListener("mouseleave", () => {
      this.visible = false;
      document.documentElement.classList.remove("cursor-active");
    });

    window.addEventListener("mousedown", () => {
      document.documentElement.classList.add("cursor-pressed");
    });

    window.addEventListener("mouseup", () => {
      document.documentElement.classList.remove("cursor-pressed");
    });

    // Grow the ring over anything clickable
    const interactive = "a, button, [role='button'], input, textarea, select, label";
    document.addEventListener("mouseover", (e) => {
      if (e.target.closest(interactive)) {
        document.documentElement.classList.add("cursor-hover");
      }
    });
    document.addEventListener("mouseout", (e) => {
      if (e.target.closest(interactive)) {
        document.documentElement.classList.remove("cursor-hover");
      }
    });
  }

  #loop() {
    const tick = () => {
      requestAnimationFrame(tick);
      this.ringX += (this.x - this.ringX) * 0.16;
      this.ringY += (this.y - this.ringY) * 0.16;
      this.dot.style.transform = `translate(${this.x}px, ${this.y}px)`;
      this.ring.style.transform = `translate(${this.ringX}px, ${this.ringY}px)`;
    };
    tick();
  }
}
